import BaseApiService from './BaseApiService'

class ReportService extends BaseApiService {
   constructor() {
      super()
   }

   async getList() {
      return await super.execute('get', `reports`)
   }

   async getRequests(guid) {
      return await super.execute('get', `reports/${guid}`)
   }

   async saveRequest(payload) {
      return await super.execute('post', `reports`, payload)
   }

   async getPendingCount() {
      return await super.execute('get', `reports/count`)
   }
}

export let reportApi = new ReportService()